export default [
  { name: 'ivu-icon-ios-add', text: 'ios-add' },

  { name: 'ivu-icon-md-add', text: 'md-add' },

  { name: 'ivu-icon-ios-add-circle', text: 'ios-add-circle' },

  { name: 'ivu-icon-ios-add-circle-outline', text: 'ios-add-circle-outline' },

  { name: 'ivu-icon-md-add-circle', text: 'md-add-circle' },

  { name: 'ivu-icon-ios-alarm', text: 'ios-alarm' },

  { name: 'ivu-icon-ios-alarm-outline', text: 'ios-alarm-outline' },

  { name: 'ivu-icon-md-alarm', text: 'md-alarm' },

  { name: 'ivu-icon-ios-albums', text: 'ios-albums' },

  { name: 'ivu-icon-ios-albums-outline', text: 'ios-albums-outline' },

  { name: 'ivu-icon-md-albums', text: 'md-albums' },

  { name: 'ivu-icon-ios-alert', text: 'ios-alert' },

  { name: 'ivu-icon-ios-alert-outline', text: 'ios-alert-outline' },

  { name: 'ivu-icon-md-alert', text: 'md-alert' },

  { name: 'ivu-icon-ios-american-football', text: 'ios-american-football' },

  { name: 'ivu-icon-ios-american-football-outline', text: 'ios-american-football-outline' },

  { name: 'ivu-icon-md-american-football', text: 'md-american-football' },

  { name: 'ivu-icon-ios-analytics', text: 'ios-analytics' },

  { name: 'ivu-icon-ios-analytics-outline', text: 'ios-analytics-outline' },

  { name: 'ivu-icon-md-analytics', text: 'md-analytics' },

  { name: 'ivu-icon-logo-android', text: 'logo-android' },

  { name: 'ivu-icon-logo-angular', text: 'logo-angular' },

  { name: 'ivu-icon-ios-aperture', text: 'ios-aperture' },

  { name: 'ivu-icon-ios-aperture-outline', text: 'ios-aperture-outline' },

  { name: 'ivu-icon-md-aperture', text: 'md-aperture' },

  { name: 'ivu-icon-logo-apple', text: 'logo-apple' },

  { name: 'ivu-icon-ios-apps', text: 'ios-apps' },

  { name: 'ivu-icon-ios-apps-outline', text: 'ios-apps-outline' },

  { name: 'ivu-icon-md-apps', text: 'md-apps' },

  { name: 'ivu-icon-ios-appstore', text: 'ios-appstore' },

  { name: 'ivu-icon-ios-appstore-outline', text: 'ios-appstore-outline' },

  { name: 'ivu-icon-md-appstore', text: 'md-appstore' },

  { name: 'ivu-icon-ios-archive', text: 'ios-archive' },

  { name: 'ivu-icon-ios-archive-outline', text: 'ios-archive-outline' },

  { name: 'ivu-icon-md-archive', text: 'md-archive' },

  { name: 'ivu-icon-ios-arrow-back', text: 'ios-arrow-back' },

  { name: 'ivu-icon-md-arrow-back', text: 'md-arrow-back' },

  { name: 'ivu-icon-ios-arrow-down', text: 'ios-arrow-down' },

  { name: 'ivu-icon-md-arrow-down', text: 'md-arrow-down' },

  { name: 'ivu-icon-ios-arrow-dropdown', text: 'ios-arrow-dropdown' },

  { name: 'ivu-icon-md-arrow-dropdown', text: 'md-arrow-dropdown' },

  { name: 'ivu-icon-ios-arrow-dropdown-circle', text: 'ios-arrow-dropdown-circle' },

  { name: 'ivu-icon-md-arrow-dropdown-circle', text: 'md-arrow-dropdown-circle' },

  { name: 'ivu-icon-ios-arrow-dropleft', text: 'ios-arrow-dropleft' },

  { name: 'ivu-icon-md-arrow-dropleft', text: 'md-arrow-dropleft' },

  { name: 'ivu-icon-ios-arrow-dropleft-circle', text: 'ios-arrow-dropleft-circle' },

  { name: 'ivu-icon-md-arrow-dropleft-circle', text: 'md-arrow-dropleft-circle' },

  { name: 'ivu-icon-ios-arrow-dropright', text: 'ios-arrow-dropright' },

  { name: 'ivu-icon-md-arrow-dropright', text: 'md-arrow-dropright' },

  { name: 'ivu-icon-ios-arrow-dropright-circle', text: 'ios-arrow-dropright-circle' },

  { name: 'ivu-icon-md-arrow-dropright-circle', text: 'md-arrow-dropright-circle' },

  { name: 'ivu-icon-ios-arrow-dropup', text: 'ios-arrow-dropup' },

  { name: 'ivu-icon-md-arrow-dropup', text: 'md-arrow-dropup' },

  { name: 'ivu-icon-ios-arrow-dropup-circle', text: 'ios-arrow-dropup-circle' },

  { name: 'ivu-icon-md-arrow-dropup-circle', text: 'md-arrow-dropup-circle' },

  { name: 'ivu-icon-ios-arrow-forward', text: 'ios-arrow-forward' },

  { name: 'ivu-icon-md-arrow-forward', text: 'md-arrow-forward' },

  { name: 'ivu-icon-ios-arrow-round-back', text: 'ios-arrow-round-back' },

  { name: 'ivu-icon-md-arrow-round-back', text: 'md-arrow-round-back' },

  { name: 'ivu-icon-ios-arrow-round-down', text: 'ios-arrow-round-down' },

  { name: 'ivu-icon-md-arrow-round-down', text: 'md-arrow-round-down' },

  { name: 'ivu-icon-ios-arrow-round-forward', text: 'ios-arrow-round-forward' },

  { name: 'ivu-icon-md-arrow-round-forward', text: 'md-arrow-round-forward' },

  { name: 'ivu-icon-ios-arrow-round-up', text: 'ios-arrow-round-up' },

  { name: 'ivu-icon-md-arrow-round-up', text: 'md-arrow-round-up' },

  { name: 'ivu-icon-ios-arrow-up', text: 'ios-arrow-up' },

  { name: 'ivu-icon-md-arrow-up', text: 'md-arrow-up' },

  { name: 'ivu-icon-ios-at', text: 'ios-at' },

  { name: 'ivu-icon-ios-at-outline', text: 'ios-at-outline' },

  { name: 'ivu-icon-md-attach', text: 'md-at' },

  { name: 'ivu-icon-ios-attach', text: 'ios-attach' },

  { name: 'ivu-icon-md-attach', text: 'md-attach' },

  { name: 'ivu-icon-ios-backspace', text: 'ios-backspace' },

  { name: 'ivu-icon-ios-backspace-outline', text: 'ios-backspace-outline' },

  { name: 'ivu-icon-md-backspace', text: 'md-backspace' },

  { name: 'ivu-icon-ios-barcode', text: 'ios-barcode' },

  { name: 'ivu-icon-ios-barcode-outline', text: 'ios-barcode-outline' },

  { name: 'ivu-icon-md-barcode', text: 'md-barcode' },

  { name: 'ivu-icon-ios-baseball', text: 'ios-baseball' },

  { name: 'ivu-icon-ios-baseball-outline', text: 'ios-baseball-outline' },

  { name: 'ivu-icon-md-baseball', text: 'md-baseball' },

  { name: 'ivu-icon-ios-basket', text: 'ios-basket' },

  { name: 'ivu-icon-ios-basket-outline', text: 'ios-basket-outline' },

  { name: 'ivu-icon-md-basket', text: 'md-basket' },

  { name: 'ivu-icon-ios-basketball', text: 'ios-basketball' },

  { name: 'ivu-icon-ios-basketball-outline', text: 'ios-basketball-outline' },

  { name: 'ivu-icon-md-basketball', text: 'md-basketball' },

  { name: 'ivu-icon-ios-battery-charging', text: 'ios-battery-charging' },

  { name: 'ivu-icon-md-battery-charging', text: 'md-battery-charging' },

  { name: 'ivu-icon-ios-battery-dead', text: 'ios-battery-dead' },

  { name: 'ivu-icon-md-battery-dead', text: 'md-battery-dead' },

  { name: 'ivu-icon-ios-battery-full', text: 'ios-battery-full' },

  { name: 'ivu-icon-md-battery-full', text: 'md-battery-full' },

  { name: 'ivu-icon-ios-beaker', text: 'ios-beaker' },

  { name: 'ivu-icon-ios-beaker-outline', text: 'ios-beaker-outline' },

  { name: 'ivu-icon-md-beaker', text: 'md-beaker' },

  { name: 'ivu-icon-ios-beer', text: 'ios-beer' },

  { name: 'ivu-icon-ios-beer-outline', text: 'ios-beer-outline' },

  { name: 'ivu-icon-md-beer', text: 'md-beer' },

  { name: 'ivu-icon-ios-bicycle', text: 'ios-bicycle' },

  { name: 'ivu-icon-md-bicycle', text: 'md-bicycle' },

  { name: 'ivu-icon-logo-bitcoin', text: 'logo-bitcoin' },

  { name: 'ivu-icon-ios-bluetooth', text: 'ios-bluetooth' },

  { name: 'ivu-icon-md-bluetooth', text: 'md-bluetooth' },

  { name: 'ivu-icon-ios-boat', text: 'ios-boat' },

  { name: 'ivu-icon-ios-boat-outline', text: 'ios-boat-outline' },

  { name: 'ivu-icon-md-boat', text: 'md-boat' },

  { name: 'ivu-icon-ios-body', text: 'ios-body' },

  { name: 'ivu-icon-ios-body-outline', text: 'ios-body-outline' },

  { name: 'ivu-icon-md-body', text: 'md-body' },

  { name: 'ivu-icon-ios-bonfire', text: 'ios-bonfire' },

  { name: 'ivu-icon-ios-bonfire-outline', text: 'ios-bonfire-outline' },

  { name: 'ivu-icon-md-bonfire', text: 'md-bonfire' },

  { name: 'ivu-icon-ios-book', text: 'ios-book' },

  { name: 'ivu-icon-ios-book-outline', text: 'ios-book-outline' },

  { name: 'ivu-icon-md-book', text: 'md-book' },

  { name: 'ivu-icon-ios-bookmark', text: 'ios-bookmark' },

  { name: 'ivu-icon-ios-bookmark-outline', text: 'ios-bookmark-outline' },

  { name: 'ivu-icon-md-bookmark', text: 'md-bookmark' },

  { name: 'ivu-icon-ios-bookmarks', text: 'ios-bookmarks' },

  { name: 'ivu-icon-ios-bookmarks-outline', text: 'ios-bookmarks-outline' },

  { name: 'ivu-icon-md-bookmarks', text: 'md-bookmarks' },

  { name: 'ivu-icon-ios-bowtie', text: 'ios-bowtie' },

  { name: 'ivu-icon-ios-bowtie-outline', text: 'ios-bowtie-outline' },

  { name: 'ivu-icon-md-bowtie', text: 'md-bowtie' },

  { name: 'ivu-icon-ios-briefcase', text: 'ios-briefcase' },

  { name: 'ivu-icon-ios-briefcase-outline', text: 'ios-briefcase-outline' },

  { name: 'ivu-icon-md-briefcase', text: 'md-briefcase' },

  { name: 'ivu-icon-ios-browsers', text: 'ios-browsers' },

  { name: 'ivu-icon-ios-browsers-outline', text: 'ios-browsers-outline' },

  { name: 'ivu-icon-md-browsers', text: 'md-browsers' },

  { name: 'ivu-icon-ios-brush', text: 'ios-brush' },

  { name: 'ivu-icon-ios-brush-outline', text: 'ios-brush-outline' },

  { name: 'ivu-icon-md-brush', text: 'md-brush' },

  { name: 'ivu-icon-logo-buffer', text: 'logo-buffer' },

  { name: 'ivu-icon-ios-bug', text: 'ios-bug' },

  { name: 'ivu-icon-ios-bug-outline', text: 'ios-bug-outline' },

  { name: 'ivu-icon-md-bug', text: 'md-bug' },

  { name: 'ivu-icon-ios-build', text: 'ios-build' },

  { name: 'ivu-icon-ios-build-outline', text: 'ios-build-outline' },

  { name: 'ivu-icon-md-build', text: 'md-build' },

  { name: 'ivu-icon-ios-bulb', text: 'ios-bulb' },

  { name: 'ivu-icon-ios-bulb-outline', text: 'ios-bulb-outline' },

  { name: 'ivu-icon-md-bulb', text: 'md-bulb' },

  { name: 'ivu-icon-ios-bus', text: 'ios-bus' },

  { name: 'ivu-icon-ios-bus-outline', text: 'ios-bus-outline' },

  { name: 'ivu-icon-md-bus', text: 'md-bus' },

  { name: 'ivu-icon-ios-cafe', text: 'ios-cafe' },

  { name: 'ivu-icon-ios-cafe-outline', text: 'ios-cafe-outline' },

  { name: 'ivu-icon-md-cafe', text: 'md-cafe' },

  { name: 'ivu-icon-ios-calculator', text: 'ios-calculator' },

  { name: 'ivu-icon-ios-calculator-outline', text: 'ios-calculator-outline' },

  { name: 'ivu-icon-md-calculator', text: 'md-calculator' },

  { name: 'ivu-icon-ios-calendar', text: 'ios-calendar' },

  { name: 'ivu-icon-ios-calendar-outline', text: 'ios-calendar-outline' },

  { name: 'ivu-icon-md-calendar', text: 'md-calendar' },

  { name: 'ivu-icon-ios-call', text: 'ios-call' },

  { name: 'ivu-icon-ios-call-outline', text: 'ios-call-outline' },

  { name: 'ivu-icon-md-call', text: 'md-call' },

  { name: 'ivu-icon-ios-camera', text: 'ios-camera' },

  { name: 'ivu-icon-ios-camera-outline', text: 'ios-camera-outline' },

  { name: 'ivu-icon-md-camera', text: 'md-camera' },

  { name: 'ivu-icon-ios-car', text: 'ios-car' },

  { name: 'ivu-icon-ios-car-outline', text: 'ios-car-outline' },

  { name: 'ivu-icon-md-car', text: 'md-car' },

  { name: 'ivu-icon-ios-card', text: 'ios-card' },

  { name: 'ivu-icon-ios-card-outline', text: 'ios-card-outline' },

  { name: 'ivu-icon-md-card', text: 'md-card' },

  { name: 'ivu-icon-ios-cart', text: 'ios-cart' },

  { name: 'ivu-icon-ios-cart-outline', text: 'ios-cart-outline' },

  { name: 'ivu-icon-md-cart', text: 'md-cart' },

  { name: 'ivu-icon-ios-cash', text: 'ios-cash' },

  { name: 'ivu-icon-ios-cash-outline', text: 'ios-cash-outline' },

  { name: 'ivu-icon-md-cash', text: 'md-cash' },

  { name: 'ivu-icon-ios-chatboxes', text: 'ios-chatboxes' },

  { name: 'ivu-icon-ios-chatboxes-outline', text: 'ios-chatboxes-outline' },

  { name: 'ivu-icon-md-chatboxes', text: 'md-chatboxes' },

  { name: 'ivu-icon-ios-chatbubbles', text: 'ios-chatbubbles' },

  { name: 'ivu-icon-ios-chatbubbles-outline', text: 'ios-chatbubbles-outline' },

  { name: 'ivu-icon-md-chatbubbles', text: 'md-chatbubbles' },

  { name: 'ivu-icon-ios-checkbox', text: 'ios-checkbox' },

  { name: 'ivu-icon-ios-checkbox-outline', text: 'ios-checkbox-outline' },

  { name: 'ivu-icon-md-checkbox', text: 'md-checkbox' },

  { name: 'ivu-icon-md-checkbox-outline', text: 'md-checkbox-outline' },

  { name: 'ivu-icon-ios-checkmark', text: 'ios-checkmark' },

  { name: 'ivu-icon-md-checkmark', text: 'md-checkmark' },

  { name: 'ivu-icon-ios-checkmark-circle', text: 'ios-checkmark-circle' },

  { name: 'ivu-icon-ios-checkmark-circle-outline', text: 'ios-checkmark-circle-outline' },

  { name: 'ivu-icon-md-checkmark-circle', text: 'md-checkmark-circle' },

  { name: 'ivu-icon-md-checkmark-circle-outline', text: 'md-checkmark-circle-outline' },

  { name: 'ivu-icon-logo-chrome', text: 'logo-chrome' },

  { name: 'ivu-icon-ios-clipboard', text: 'ios-clipboard' },

  { name: 'ivu-icon-ios-clipboard-outline', text: 'ios-clipboard-outline' },

  { name: 'ivu-icon-md-clipboard', text: 'md-clipboard' },

  { name: 'ivu-icon-ios-clock', text: 'ios-clock' },

  { name: 'ivu-icon-ios-clock-outline', text: 'ios-clock-outline' },

  { name: 'ivu-icon-md-clock', text: 'md-clock' },

  { name: 'ivu-icon-ios-close', text: 'ios-close' },

  { name: 'ivu-icon-md-close', text: 'md-close' },

  { name: 'ivu-icon-ios-close-circle', text: 'ios-close-circle' },

  { name: 'ivu-icon-ios-close-circle-outline', text: 'ios-close-circle-outline' },

  { name: 'ivu-icon-md-close-circle', text: 'md-close-circle' },

  { name: 'ivu-icon-ios-closed-captioning', text: 'ios-closed-captioning' },

  { name: 'ivu-icon-ios-closed-captioning-outline', text: 'ios-closed-captioning-outline' },

  { name: 'ivu-icon-md-closed-captioning', text: 'md-closed-captioning' },

  { name: 'ivu-icon-ios-cloud', text: 'ios-cloud' },

  { name: 'ivu-icon-ios-cloud-outline', text: 'ios-cloud-outline' },

  { name: 'ivu-icon-md-cloud', text: 'md-cloud' },

  { name: 'ivu-icon-ios-cloud-circle', text: 'ios-cloud-circle' },

  { name: 'ivu-icon-ios-cloud-circle-outline', text: 'ios-cloud-circle-outline' },

  { name: 'ivu-icon-md-cloud-circle', text: 'md-cloud-circle' },

  { name: 'ivu-icon-ios-cloud-done', text: 'ios-cloud-done' },

  { name: 'ivu-icon-ios-cloud-done-outline', text: 'ios-cloud-done-outline' },

  { name: 'ivu-icon-md-cloud-done', text: 'md-cloud-done' },

  { name: 'ivu-icon-ios-cloud-download', text: 'ios-cloud-download' },

  { name: 'ivu-icon-ios-cloud-download-outline', text: 'ios-cloud-download-outline' },

  { name: 'ivu-icon-md-cloud-download', text: 'md-cloud-download' },

  { name: 'ivu-icon-md-cloud-outline', text: 'md-cloud-outline' },

  { name: 'ivu-icon-ios-cloud-upload', text: 'ios-cloud-upload' },

  { name: 'ivu-icon-ios-cloud-upload-outline', text: 'ios-cloud-upload-outline' },

  { name: 'ivu-icon-md-cloud-upload', text: 'md-cloud-upload' },

  { name: 'ivu-icon-ios-cloudy', text: 'ios-cloudy' },

  { name: 'ivu-icon-ios-cloudy-outline', text: 'ios-cloudy-outline' },

  { name: 'ivu-icon-md-cloudy', text: 'md-cloudy' },

  { name: 'ivu-icon-ios-cloudy-night', text: 'ios-cloudy-night' },

  { name: 'ivu-icon-ios-cloudy-night-outline', text: 'ios-cloudy-night-outline' },

  { name: 'ivu-icon-md-cloudy-night', text: 'md-cloudy-night' },

  { name: 'ivu-icon-ios-code', text: 'ios-code' },

  { name: 'ivu-icon-md-code', text: 'md-code' },

  { name: 'ivu-icon-ios-code-download', text: 'ios-code-download' },

  { name: 'ivu-icon-md-code-download', text: 'md-code-download' },

  { name: 'ivu-icon-ios-code-working', text: 'ios-code-working' },

  { name: 'ivu-icon-md-code-working', text: 'md-code-working' },

  { name: 'ivu-icon-logo-codepen', text: 'logo-codepen' },

  { name: 'ivu-icon-ios-cog', text: 'ios-cog' },

  { name: 'ivu-icon-ios-cog-outline', text: 'ios-cog-outline' },

  { name: 'ivu-icon-md-cog', text: 'md-cog' },

  { name: 'ivu-icon-ios-color-fill', text: 'ios-color-fill' },

  { name: 'ivu-icon-ios-color-fill-outline', text: 'ios-color-fill-outline' },

  { name: 'ivu-icon-md-color-fill', text: 'md-color-fill' },

  { name: 'ivu-icon-ios-color-filter', text: 'ios-color-filter' },

  { name: 'ivu-icon-ios-color-filter-outline', text: 'ios-color-filter-outline' },

  { name: 'ivu-icon-md-color-filter', text: 'md-color-filter' },

  { name: 'ivu-icon-ios-color-palette', text: 'ios-color-palette' },

  { name: 'ivu-icon-ios-color-palette-outline', text: 'ios-color-palette-outline' },

  { name: 'ivu-icon-md-color-palette', text: 'md-color-palette' },

  { name: 'ivu-icon-ios-color-wand', text: 'ios-color-wand' },

  { name: 'ivu-icon-ios-color-wand-outline', text: 'ios-color-wand-outline' },

  { name: 'ivu-icon-md-color-wand', text: 'md-color-wand' },

  { name: 'ivu-icon-ios-compass', text: 'ios-compass' },

  { name: 'ivu-icon-ios-compass-outline', text: 'ios-compass-outline' },

  { name: 'ivu-icon-md-compass', text: 'md-compass' },

  { name: 'ivu-icon-ios-construct', text: 'ios-construct' },

  { name: 'ivu-icon-ios-construct-outline', text: 'ios-construct-outline' },

  { name: 'ivu-icon-md-construct', text: 'md-construct' },

  { name: 'ivu-icon-ios-contact', text: 'ios-contact' },

  { name: 'ivu-icon-ios-contact-outline', text: 'ios-contact-outline' },

  { name: 'ivu-icon-md-contact', text: 'md-contact' },

  { name: 'ivu-icon-ios-contacts', text: 'ios-contacts' },

  { name: 'ivu-icon-ios-contacts-outline', text: 'ios-contacts-outline' },

  { name: 'ivu-icon-md-contacts', text: 'md-contacts' },

  { name: 'ivu-icon-ios-contract', text: 'ios-contract' },

  { name: 'ivu-icon-md-contract', text: 'md-contract' },

  { name: 'ivu-icon-ios-contrast', text: 'ios-contrast' },

  { name: 'ivu-icon-md-contrast', text: 'md-contrast' },

  { name: 'ivu-icon-ios-copy', text: 'ios-copy' },

  { name: 'ivu-icon-ios-copy-outline', text: 'ios-copy-outline' },

  { name: 'ivu-icon-md-copy', text: 'md-copy' },

  { name: 'ivu-icon-ios-create', text: 'ios-create' },

  { name: 'ivu-icon-ios-create-outline', text: 'ios-create-outline' },

  { name: 'ivu-icon-md-create', text: 'md-create' },

  { name: 'ivu-icon-ios-crop', text: 'ios-crop' },

  { name: 'ivu-icon-ios-crop-outline', text: 'ios-crop-outline' },

  { name: 'ivu-icon-md-crop', text: 'md-crop' },

  { name: 'ivu-icon-logo-css3', text: 'logo-css3' },

  { name: 'ivu-icon-ios-cube', text: 'ios-cube' },

  { name: 'ivu-icon-ios-cube-outline', text: 'ios-cube-outline' },

  { name: 'ivu-icon-md-cube', text: 'md-cube' },

  { name: 'ivu-icon-ios-cut', text: 'ios-cut' },

  { name: 'ivu-icon-ios-cut-outline', text: 'ios-cut-outline' },

  { name: 'ivu-icon-md-cut', text: 'md-cut' },

  { name: 'ivu-icon-logo-designernews', text: 'logo-designernews' },

  { name: 'ivu-icon-ios-desktop', text: 'ios-desktop' },

  { name: 'ivu-icon-ios-desktop-outline', text: 'ios-desktop-outline' },

  { name: 'ivu-icon-md-desktop', text: 'md-desktop' },

  { name: 'ivu-icon-ios-disc', text: 'ios-disc' },

  { name: 'ivu-icon-ios-disc-outline', text: 'ios-disc-outline' },

  { name: 'ivu-icon-md-disc', text: 'md-disc' },

  { name: 'ivu-icon-ios-document', text: 'ios-document' },

  { name: 'ivu-icon-ios-document-outline', text: 'ios-document-outline' },

  { name: 'ivu-icon-md-document', text: 'md-document' },

  { name: 'ivu-icon-ios-done-all', text: 'ios-done-all' },

  { name: 'ivu-icon-md-done-all', text: 'md-done-all' },

  { name: 'ivu-icon-ios-download', text: 'ios-download' },

  { name: 'ivu-icon-ios-download-outline', text: 'ios-download-outline' },

  { name: 'ivu-icon-md-download', text: 'md-download' },

  { name: 'ivu-icon-logo-dribbble', text: 'logo-dribbble' },

  { name: 'ivu-icon-logo-dropbox', text: 'logo-dropbox' },

  { name: 'ivu-icon-ios-easel', text: 'ios-easel' },

  { name: 'ivu-icon-ios-easel-outline', text: 'ios-easel-outline' },

  { name: 'ivu-icon-md-easel', text: 'md-easel' },

  { name: 'ivu-icon-ios-egg', text: 'ios-egg' },

  { name: 'ivu-icon-ios-egg-outline', text: 'ios-egg-outline' },

  { name: 'ivu-icon-md-egg', text: 'md-egg' },

  { name: 'ivu-icon-logo-euro', text: 'logo-euro' },

  { name: 'ivu-icon-ios-exit', text: 'ios-exit' },

  { name: 'ivu-icon-ios-exit-outline', text: 'ios-exit-outline' },

  { name: 'ivu-icon-md-exit', text: 'md-exit' },

  { name: 'ivu-icon-ios-expand', text: 'ios-expand' },

  { name: 'ivu-icon-md-expand', text: 'md-expand' },

  { name: 'ivu-icon-ios-eye', text: 'ios-eye' },

  { name: 'ivu-icon-ios-eye-outline', text: 'ios-eye-outline' },

  { name: 'ivu-icon-md-eye', text: 'md-eye' },

  { name: 'ivu-icon-ios-eye-off', text: 'ios-eye-off' },

  { name: 'ivu-icon-ios-eye-off-outline', text: 'ios-eye-off-outline' },

  { name: 'ivu-icon-md-eye-off', text: 'md-eye-off' },

  { name: 'ivu-icon-logo-facebook', text: 'logo-facebook' },

  { name: 'ivu-icon-ios-fastforward', text: 'ios-fastforward' },

  { name: 'ivu-icon-ios-fastforward-outline', text: 'ios-fastforward-outline' },

  { name: 'ivu-icon-md-fastforward', text: 'md-fastforward' },

  { name: 'ivu-icon-ios-female', text: 'ios-female' },

  { name: 'ivu-icon-md-female', text: 'md-female' },

  { name: 'ivu-icon-ios-filing', text: 'ios-filing' },

  { name: 'ivu-icon-ios-filing-outline', text: 'ios-filing-outline' },

  { name: 'ivu-icon-md-filing', text: 'md-filing' },

  { name: 'ivu-icon-ios-film', text: 'ios-film' },

  { name: 'ivu-icon-ios-film-outline', text: 'ios-film-outline' },

  { name: 'ivu-icon-md-film', text: 'md-film' },

  { name: 'ivu-icon-ios-finger-print', text: 'ios-finger-print' },

  { name: 'ivu-icon-md-finger-print', text: 'md-finger-print' },

  { name: 'ivu-icon-ios-flag', text: 'ios-flag' },

  { name: 'ivu-icon-ios-flag-outline', text: 'ios-flag-outline' },

  { name: 'ivu-icon-md-flag', text: 'md-flag' },

  { name: 'ivu-icon-ios-flame', text: 'ios-flame' },

  { name: 'ivu-icon-ios-flame-outline', text: 'ios-flame-outline' },

  { name: 'ivu-icon-md-flame', text: 'md-flame' },

  { name: 'ivu-icon-ios-flash', text: 'ios-flash' },

  { name: 'ivu-icon-ios-flash-outline', text: 'ios-flash-outline' },

  { name: 'ivu-icon-md-flash', text: 'md-flash' },

  { name: 'ivu-icon-ios-flask', text: 'ios-flask' },

  { name: 'ivu-icon-ios-flask-outline', text: 'ios-flask-outline' },

  { name: 'ivu-icon-md-flask', text: 'md-flask' },

  { name: 'ivu-icon-ios-flower', text: 'ios-flower' },

  { name: 'ivu-icon-ios-flower-outline', text: 'ios-flower-outline' },

  { name: 'ivu-icon-md-flower', text: 'md-flower' },

  { name: 'ivu-icon-ios-folder', text: 'ios-folder' },

  { name: 'ivu-icon-ios-folder-outline', text: 'ios-folder-outline' },

  { name: 'ivu-icon-md-folder', text: 'md-folder' },

  { name: 'ivu-icon-ios-folder-open', text: 'ios-folder-open' },

  { name: 'ivu-icon-ios-folder-open-outline', text: 'ios-folder-open-outline' },

  { name: 'ivu-icon-md-folder-open', text: 'md-folder-open' },

  { name: 'ivu-icon-ios-football', text: 'ios-football' },

  { name: 'ivu-icon-ios-football-outline', text: 'ios-football-outline' },

  { name: 'ivu-icon-md-football', text: 'md-football' },

  { name: 'ivu-icon-logo-foursquare', text: 'logo-foursquare' },

  { name: 'ivu-icon-logo-freebsd-devil', text: 'logo-freebsd-devil' },

  { name: 'ivu-icon-ios-funnel', text: 'ios-funnel' },

  { name: 'ivu-icon-ios-funnel-outline', text: 'ios-funnel-outline' },

  { name: 'ivu-icon-md-funnel', text: 'md-funnel' },

  { name: 'ivu-icon-ios-game-controller-a', text: 'ios-game-controller-a' },

  { name: 'ivu-icon-ios-game-controller-a-outline', text: 'ios-game-controller-a-outline' },

  { name: 'ivu-icon-md-game-controller-a', text: 'md-game-controller-a' },

  { name: 'ivu-icon-ios-game-controller-b', text: 'ios-game-controller-b' },

  { name: 'ivu-icon-ios-game-controller-b-outline', text: 'ios-game-controller-b-outline' },

  { name: 'ivu-icon-md-game-controller-b', text: 'md-game-controller-b' },

  { name: 'ivu-icon-ios-git-branch', text: 'ios-git-branch' },

  { name: 'ivu-icon-md-git-branch', text: 'md-git-branch' },

  { name: 'ivu-icon-ios-git-commit', text: 'ios-git-commit' },

  { name: 'ivu-icon-md-git-commit', text: 'md-git-commit' },

  { name: 'ivu-icon-ios-git-compare', text: 'ios-git-compare' },

  { name: 'ivu-icon-md-git-compare', text: 'md-git-compare' },

  { name: 'ivu-icon-ios-git-merge', text: 'ios-git-merge' },

  { name: 'ivu-icon-md-git-merge', text: 'md-git-merge' },

  { name: 'ivu-icon-ios-git-network', text: 'ios-git-network' },

  { name: 'ivu-icon-md-git-network', text: 'md-git-network' },

  { name: 'ivu-icon-ios-git-pull-request', text: 'ios-git-pull-request' },

  { name: 'ivu-icon-md-git-pull-request', text: 'md-git-pull-request' },

  { name: 'ivu-icon-logo-github', text: 'logo-github' },

  { name: 'ivu-icon-ios-glasses', text: 'ios-glasses' },

  { name: 'ivu-icon-ios-glasses-outline', text: 'ios-glasses-outline' },

  { name: 'ivu-icon-md-glasses', text: 'md-glasses' },

  { name: 'ivu-icon-ios-globe', text: 'ios-globe' },

  { name: 'ivu-icon-ios-globe-outline', text: 'ios-globe-outline' },

  { name: 'ivu-icon-md-globe', text: 'md-globe' },

  { name: 'ivu-icon-logo-google', text: 'logo-google' },

  { name: 'ivu-icon-logo-googleplus', text: 'logo-googleplus' },

  { name: 'ivu-icon-ios-grid', text: 'ios-grid' },

  { name: 'ivu-icon-ios-grid-outline', text: 'ios-grid-outline' },

  { name: 'ivu-icon-md-grid', text: 'md-grid' },

  { name: 'ivu-icon-logo-hackernews', text: 'logo-hackernews' },

  { name: 'ivu-icon-ios-hammer', text: 'ios-hammer' },

  { name: 'ivu-icon-ios-hammer-outline', text: 'ios-hammer-outline' },

  { name: 'ivu-icon-md-hammer', text: 'md-hammer' },

  { name: 'ivu-icon-ios-hand', text: 'ios-hand' },

  { name: 'ivu-icon-ios-hand-outline', text: 'ios-hand-outline' },

  { name: 'ivu-icon-md-hand', text: 'md-hand' },

  { name: 'ivu-icon-ios-happy', text: 'ios-happy' },

  { name: 'ivu-icon-ios-happy-outline', text: 'ios-happy-outline' },

  { name: 'ivu-icon-md-happy', text: 'md-happy' },

  { name: 'ivu-icon-ios-headset', text: 'ios-headset' },

  { name: 'ivu-icon-ios-headset-outline', text: 'ios-headset-outline' },

  { name: 'ivu-icon-md-headset', text: 'md-headset' },

  { name: 'ivu-icon-ios-heart', text: 'ios-heart' },

  { name: 'ivu-icon-ios-heart-outline', text: 'ios-heart-outline' },

  { name: 'ivu-icon-md-heart', text: 'md-heart' },

  { name: 'ivu-icon-md-heart-outline', text: 'md-heart-outline' },

  { name: 'ivu-icon-ios-help', text: 'ios-help' },

  { name: 'ivu-icon-md-help', text: 'md-help' },

  { name: 'ivu-icon-ios-help-buoy', text: 'ios-help-buoy' },

  { name: 'ivu-icon-ios-help-buoy-outline', text: 'ios-help-buoy-outline' },

  { name: 'ivu-icon-md-help-buoy', text: 'md-help-buoy' },

  { name: 'ivu-icon-ios-help-circle', text: 'ios-help-circle' },

  { name: 'ivu-icon-ios-help-circle-outline', text: 'ios-help-circle-outline' },

  { name: 'ivu-icon-md-help-circle', text: 'md-help-circle' },

  { name: 'ivu-icon-ios-home', text: 'ios-home' },

  { name: 'ivu-icon-ios-home-outline', text: 'ios-home-outline' },

  { name: 'ivu-icon-md-home', text: 'md-home' },

  { name: 'ivu-icon-logo-html5', text: 'logo-html5' },

  { name: 'ivu-icon-ios-ice-cream', text: 'ios-ice-cream' },

  { name: 'ivu-icon-ios-ice-cream-outline', text: 'ios-ice-cream-outline' },

  { name: 'ivu-icon-md-ice-cream', text: 'md-ice-cream' },

  { name: 'ivu-icon-ios-image', text: 'ios-image' },

  { name: 'ivu-icon-ios-image-outline', text: 'ios-image-outline' },

  { name: 'ivu-icon-md-image', text: 'md-image' },

  { name: 'ivu-icon-ios-images', text: 'ios-images' },

  { name: 'ivu-icon-ios-images-outline', text: 'ios-images-outline' },

  { name: 'ivu-icon-md-images', text: 'md-images' },

  { name: 'ivu-icon-ios-infinite', text: 'ios-infinite' },

  { name: 'ivu-icon-ios-infinite-outline', text: 'ios-infinite-outline' },

  { name: 'ivu-icon-md-infinite', text: 'md-infinite' },

  { name: 'ivu-icon-ios-information', text: 'ios-information' },

  { name: 'ivu-icon-md-information', text: 'md-information' },

  { name: 'ivu-icon-ios-information-circle', text: 'ios-information-circle' },

  { name: 'ivu-icon-ios-information-circle-outline', text: 'ios-information-circle-outline' },

  { name: 'ivu-icon-md-information-circle', text: 'md-information-circle' },

  { name: 'ivu-icon-logo-instagram', text: 'logo-instagram' },

  { name: 'ivu-icon-ios-ionic', text: 'ios-ionic' },

  { name: 'ivu-icon-ios-ionic-outline', text: 'ios-ionic-outline' },

  { name: 'ivu-icon-md-ionic', text: 'md-ionic' },

  { name: 'ivu-icon-ios-ionitron', text: 'ios-ionitron' },

  { name: 'ivu-icon-ios-ionitron-outline', text: 'ios-ionitron-outline' },

  { name: 'ivu-icon-md-ionitron', text: 'md-ionitron' },

  { name: 'ivu-icon-logo-javascript', text: 'logo-javascript' },

  { name: 'ivu-icon-ios-jet', text: 'ios-jet' },

  { name: 'ivu-icon-ios-jet-outline', text: 'ios-jet-outline' },

  { name: 'ivu-icon-md-jet', text: 'md-jet' },

  { name: 'ivu-icon-ios-key', text: 'ios-key' },

  { name: 'ivu-icon-ios-key-outline', text: 'ios-key-outline' },

  { name: 'ivu-icon-md-key', text: 'md-key' },

  { name: 'ivu-icon-ios-keypad', text: 'ios-keypad' },

  { name: 'ivu-icon-ios-keypad-outline', text: 'ios-keypad-outline' },

  { name: 'ivu-icon-md-keypad', text: 'md-keypad' },

  { name: 'ivu-icon-ios-laptop', text: 'ios-laptop' },

  { name: 'ivu-icon-md-laptop', text: 'md-laptop' },

  { name: 'ivu-icon-ios-leaf', text: 'ios-leaf' },

  { name: 'ivu-icon-ios-leaf-outline', text: 'ios-leaf-outline' },

  { name: 'ivu-icon-md-leaf', text: 'md-leaf' },

  { name: 'ivu-icon-ios-link', text: 'ios-link' },

  { name: 'ivu-icon-ios-link-outline', text: 'ios-link-outline' },

  { name: 'ivu-icon-md-link', text: 'md-link' },

  { name: 'ivu-icon-logo-linkedin', text: 'logo-linkedin' },

  { name: 'ivu-icon-ios-list', text: 'ios-list' },

  { name: 'ivu-icon-md-list', text: 'md-list' },

  { name: 'ivu-icon-ios-list-box', text: 'ios-list-box' },

  { name: 'ivu-icon-ios-list-box-outline', text: 'ios-list-box-outline' },

  { name: 'ivu-icon-md-list-box', text: 'md-list-box' },

  { name: 'ivu-icon-ios-locate', text: 'ios-locate' },

  { name: 'ivu-icon-ios-locate-outline', text: 'ios-locate-outline' },

  { name: 'ivu-icon-md-locate', text: 'md-locate' },

  { name: 'ivu-icon-ios-lock', text: 'ios-lock' },

  { name: 'ivu-icon-ios-lock-outline', text: 'ios-lock-outline' },

  { name: 'ivu-icon-md-lock', text: 'md-lock' },

  { name: 'ivu-icon-ios-log-in', text: 'ios-log-in' },

  { name: 'ivu-icon-md-log-in', text: 'md-log-in' },

  { name: 'ivu-icon-ios-log-out', text: 'ios-log-out' },

  { name: 'ivu-icon-md-log-out', text: 'md-log-out' },

  { name: 'ivu-icon-ios-magnet', text: 'ios-magnet' },

  { name: 'ivu-icon-ios-magnet-outline', text: 'ios-magnet-outline' },

  { name: 'ivu-icon-md-magnet', text: 'md-magnet' },

  { name: 'ivu-icon-ios-mail', text: 'ios-mail' },

  { name: 'ivu-icon-ios-mail-outline', text: 'ios-mail-outline' },

  { name: 'ivu-icon-md-mail', text: 'md-mail' },

  { name: 'ivu-icon-ios-mail-open', text: 'ios-mail-open' },

  { name: 'ivu-icon-ios-mail-open-outline', text: 'ios-mail-open-outline' },

  { name: 'ivu-icon-md-mail-open', text: 'md-mail-open' },

  { name: 'ivu-icon-ios-male', text: 'ios-male' },

  { name: 'ivu-icon-md-male', text: 'md-male' },

  { name: 'ivu-icon-ios-man', text: 'ios-man' },

  { name: 'ivu-icon-ios-man-outline', text: 'ios-man-outline' },

  { name: 'ivu-icon-md-man', text: 'md-man' },

  { name: 'ivu-icon-ios-map', text: 'ios-map' },

  { name: 'ivu-icon-ios-map-outline', text: 'ios-map-outline' },

  { name: 'ivu-icon-md-map', text: 'md-map' },

  { name: 'ivu-icon-logo-markdown', text: 'logo-markdown' },

  { name: 'ivu-icon-ios-medal', text: 'ios-medal' },

  { name: 'ivu-icon-ios-medal-outline', text: 'ios-medal-outline' },

  { name: 'ivu-icon-md-medal', text: 'md-medal' },

  { name: 'ivu-icon-ios-medical', text: 'ios-medical' },

  { name: 'ivu-icon-ios-medical-outline', text: 'ios-medical-outline' },

  { name: 'ivu-icon-md-medical', text: 'md-medical' },

  { name: 'ivu-icon-ios-medkit', text: 'ios-medkit' },

  { name: 'ivu-icon-ios-medkit-outline', text: 'ios-medkit-outline' },

  { name: 'ivu-icon-md-medkit', text: 'md-medkit' },

  { name: 'ivu-icon-ios-megaphone', text: 'ios-megaphone' },

  { name: 'ivu-icon-ios-megaphone-outline', text: 'ios-megaphone-outline' },

  { name: 'ivu-icon-md-megaphone', text: 'md-megaphone' },

  { name: 'ivu-icon-ios-menu', text: 'ios-menu' },

  { name: 'ivu-icon-ios-menu-outline', text: 'ios-menu-outline' },

  { name: 'ivu-icon-md-menu', text: 'md-menu' },

  { name: 'ivu-icon-ios-mic', text: 'ios-mic' },

  { name: 'ivu-icon-ios-mic-outline', text: 'ios-mic-outline' },

  { name: 'ivu-icon-md-mic', text: 'md-mic' },

  { name: 'ivu-icon-ios-mic-off', text: 'ios-mic-off' },

  { name: 'ivu-icon-ios-mic-off-outline', text: 'ios-mic-off-outline' },

  { name: 'ivu-icon-md-mic-off', text: 'md-mic-off' },

  { name: 'ivu-icon-ios-microphone', text: 'ios-microphone' },

  { name: 'ivu-icon-ios-microphone-outline', text: 'ios-microphone-outline' },

  { name: 'ivu-icon-md-microphone', text: 'md-microphone' },

  { name: 'ivu-icon-ios-moon', text: 'ios-moon' },

  { name: 'ivu-icon-ios-moon-outline', text: 'ios-moon-outline' },

  { name: 'ivu-icon-md-moon', text: 'md-moon' },

  { name: 'ivu-icon-ios-more', text: 'ios-more' },

  { name: 'ivu-icon-ios-more-outline', text: 'ios-more-outline' },

  { name: 'ivu-icon-md-more', text: 'md-more' },

  { name: 'ivu-icon-ios-move', text: 'ios-move' },

  { name: 'ivu-icon-md-move', text: 'md-move' },

  { name: 'ivu-icon-ios-musical-note', text: 'ios-musical-note' },

  { name: 'ivu-icon-ios-musical-note-outline', text: 'ios-musical-note-outline' },

  { name: 'ivu-icon-md-musical-note', text: 'md-musical-note' },

  { name: 'ivu-icon-ios-musical-notes', text: 'ios-musical-notes' },

  { name: 'ivu-icon-ios-musical-notes-outline', text: 'ios-musical-notes-outline' },

  { name: 'ivu-icon-md-musical-notes', text: 'md-musical-notes' },

  { name: 'ivu-icon-ios-navigate', text: 'ios-navigate' },

  { name: 'ivu-icon-ios-navigate-outline', text: 'ios-navigate-outline' },

  { name: 'ivu-icon-md-navigate', text: 'md-navigate' },

  { name: 'ivu-icon-ios-no-smoking', text: 'ios-no-smoking' },

  { name: 'ivu-icon-ios-no-smoking-outline', text: 'ios-no-smoking-outline' },

  { name: 'ivu-icon-md-no-smoking', text: 'md-no-smoking' },

  { name: 'ivu-icon-logo-nodejs', text: 'logo-nodejs' },

  { name: 'ivu-icon-ios-notifications', text: 'ios-notifications' },

  { name: 'ivu-icon-ios-notifications-outline', text: 'ios-notifications-outline' },

  { name: 'ivu-icon-md-notifications', text: 'md-notifications' },

  { name: 'ivu-icon-ios-notifications-off', text: 'ios-notifications-off' },

  { name: 'ivu-icon-ios-notifications-off-outline', text: 'ios-notifications-off-outline' },

  { name: 'ivu-icon-md-notifications-off', text: 'md-notifications-off' },

  { name: 'ivu-icon-md-notifications-outline', text: 'md-notifications-outline' },

  { name: 'ivu-icon-ios-nuclear', text: 'ios-nuclear' },

  { name: 'ivu-icon-ios-nuclear-outline', text: 'ios-nuclear-outline' },

  { name: 'ivu-icon-md-nuclear', text: 'md-nuclear' },

  { name: 'ivu-icon-ios-nutrition', text: 'ios-nutrition' },

  { name: 'ivu-icon-ios-nutrition-outline', text: 'ios-nutrition-outline' },

  { name: 'ivu-icon-md-nutrition', text: 'md-nutrition' },

  { name: 'ivu-icon-logo-octocat', text: 'logo-octocat' },

  { name: 'ivu-icon-ios-open', text: 'ios-open' },

  { name: 'ivu-icon-ios-open-outline', text: 'ios-open-outline' },

  { name: 'ivu-icon-md-open', text: 'md-open' },

  { name: 'ivu-icon-ios-options', text: 'ios-options' },

  { name: 'ivu-icon-ios-options-outline', text: 'ios-options-outline' },

  { name: 'ivu-icon-md-options', text: 'md-options' },

  { name: 'ivu-icon-ios-outlet', text: 'ios-outlet' },

  { name: 'ivu-icon-ios-outlet-outline', text: 'ios-outlet-outline' },

  { name: 'ivu-icon-md-outlet', text: 'md-outlet' },

  { name: 'ivu-icon-ios-paper', text: 'ios-paper' },

  { name: 'ivu-icon-ios-paper-outline', text: 'ios-paper-outline' },

  { name: 'ivu-icon-md-paper', text: 'md-paper' },

  { name: 'ivu-icon-ios-paper-plane', text: 'ios-paper-plane' },

  { name: 'ivu-icon-ios-paper-plane-outline', text: 'ios-paper-plane-outline' },

  { name: 'ivu-icon-md-paper-plane', text: 'md-paper-plane' },

  { name: 'ivu-icon-ios-partly-sunny', text: 'ios-partly-sunny' },

  { name: 'ivu-icon-ios-partly-sunny-outline', text: 'ios-partly-sunny-outline' },

  { name: 'ivu-icon-md-partly-sunny', text: 'md-partly-sunny' },

  { name: 'ivu-icon-ios-pause', text: 'ios-pause' },

  { name: 'ivu-icon-ios-pause-outline', text: 'ios-pause-outline' },

  { name: 'ivu-icon-md-pause', text: 'md-pause' },

  { name: 'ivu-icon-ios-paw', text: 'ios-paw' },

  { name: 'ivu-icon-ios-paw-outline', text: 'ios-paw-outline' },

  { name: 'ivu-icon-md-paw', text: 'md-paw' },

  { name: 'ivu-icon-ios-people', text: 'ios-people' },

  { name: 'ivu-icon-ios-people-outline', text: 'ios-people-outline' },

  { name: 'ivu-icon-md-people', text: 'md-people' },

  { name: 'ivu-icon-ios-person', text: 'ios-person' },

  { name: 'ivu-icon-ios-person-outline', text: 'ios-person-outline' },

  { name: 'ivu-icon-md-person', text: 'md-person' },

  { name: 'ivu-icon-ios-person-add', text: 'ios-person-add' },

  { name: 'ivu-icon-ios-person-add-outline', text: 'ios-person-add-outline' },

  { name: 'ivu-icon-md-person-add', text: 'md-person-add' },

  { name: 'ivu-icon-ios-phone-landscape', text: 'ios-phone-landscape' },

  { name: 'ivu-icon-md-phone-landscape', text: 'md-phone-landscape' },

  { name: 'ivu-icon-ios-phone-portrait', text: 'ios-phone-portrait' },

  { name: 'ivu-icon-md-phone-portrait', text: 'md-phone-portrait' },

  { name: 'ivu-icon-ios-photos', text: 'ios-photos' },

  { name: 'ivu-icon-ios-photos-outline', text: 'ios-photos-outline' },

  { name: 'ivu-icon-md-photos', text: 'md-photos' },

  { name: 'ivu-icon-ios-pie', text: 'ios-pie' },

  { name: 'ivu-icon-ios-pie-outline', text: 'ios-pie-outline' },

  { name: 'ivu-icon-md-pie', text: 'md-pie' },

  { name: 'ivu-icon-ios-pin', text: 'ios-pin' },

  { name: 'ivu-icon-ios-pin-outline', text: 'ios-pin-outline' },

  { name: 'ivu-icon-md-pin', text: 'md-pin' },

  { name: 'ivu-icon-ios-pint', text: 'ios-pint' },

  { name: 'ivu-icon-ios-pint-outline', text: 'ios-pint-outline' },

  { name: 'ivu-icon-md-pint', text: 'md-pint' },

  { name: 'ivu-icon-logo-pinterest', text: 'logo-pinterest' },

  { name: 'ivu-icon-ios-pizza', text: 'ios-pizza' },

  { name: 'ivu-icon-ios-pizza-outline', text: 'ios-pizza-outline' },

  { name: 'ivu-icon-md-pizza', text: 'md-pizza' },

  { name: 'ivu-icon-ios-plane', text: 'ios-plane' },

  { name: 'ivu-icon-ios-plane-outline', text: 'ios-plane-outline' },

  { name: 'ivu-icon-md-plane', text: 'md-plane' },

  { name: 'ivu-icon-ios-planet', text: 'ios-planet' },

  { name: 'ivu-icon-ios-planet-outline', text: 'ios-planet-outline' },

  { name: 'ivu-icon-md-planet', text: 'md-planet' },

  { name: 'ivu-icon-ios-play', text: 'ios-play' },

  { name: 'ivu-icon-ios-play-outline', text: 'ios-play-outline' },

  { name: 'ivu-icon-md-play', text: 'md-play' },

  { name: 'ivu-icon-logo-playstation', text: 'logo-playstation' },

  { name: 'ivu-icon-ios-podium', text: 'ios-podium' },

  { name: 'ivu-icon-ios-podium-outline', text: 'ios-podium-outline' },

  { name: 'ivu-icon-md-podium', text: 'md-podium' },

  { name: 'ivu-icon-ios-power', text: 'ios-power' },

  { name: 'ivu-icon-ios-power-outline', text: 'ios-power-outline' },

  { name: 'ivu-icon-md-power', text: 'md-power' },

  { name: 'ivu-icon-ios-pricetag', text: 'ios-pricetag' },

  { name: 'ivu-icon-ios-pricetag-outline', text: 'ios-pricetag-outline' },

  { name: 'ivu-icon-md-pricetag', text: 'md-pricetag' },

  { name: 'ivu-icon-ios-pricetags', text: 'ios-pricetags' },

  { name: 'ivu-icon-ios-pricetags-outline', text: 'ios-pricetags-outline' },

  { name: 'ivu-icon-md-pricetags', text: 'md-pricetags' },

  { name: 'ivu-icon-ios-print', text: 'ios-print' },

  { name: 'ivu-icon-ios-print-outline', text: 'ios-print-outline' },

  { name: 'ivu-icon-md-print', text: 'md-print' },

  { name: 'ivu-icon-ios-pulse', text: 'ios-pulse' },

  { name: 'ivu-icon-ios-pulse-outline', text: 'ios-pulse-outline' },

  { name: 'ivu-icon-md-pulse', text: 'md-pulse' },

  { name: 'ivu-icon-logo-python', text: 'logo-python' },

  { name: 'ivu-icon-ios-qr-scanner', text: 'ios-qr-scanner' },

  { name: 'ivu-icon-md-qr-scanner', text: 'md-qr-scanner' },

  { name: 'ivu-icon-ios-quote', text: 'ios-quote' },

  { name: 'ivu-icon-ios-quote-outline', text: 'ios-quote-outline' },

  { name: 'ivu-icon-md-quote', text: 'md-quote' },

  { name: 'ivu-icon-ios-radio', text: 'ios-radio' },

  { name: 'ivu-icon-ios-radio-outline', text: 'ios-radio-outline' },

  { name: 'ivu-icon-md-radio', text: 'md-radio' },

  { name: 'ivu-icon-ios-radio-button-off', text: 'ios-radio-button-off' },

  { name: 'ivu-icon-md-radio-button-off', text: 'md-radio-button-off' },

  { name: 'ivu-icon-ios-radio-button-on', text: 'ios-radio-button-on' },

  { name: 'ivu-icon-md-radio-button-on', text: 'md-radio-button-on' },

  { name: 'ivu-icon-ios-rainy', text: 'ios-rainy' },

  { name: 'ivu-icon-ios-rainy-outline', text: 'ios-rainy-outline' },

  { name: 'ivu-icon-md-rainy', text: 'md-rainy' },

  { name: 'ivu-icon-ios-recording', text: 'ios-recording' },

  { name: 'ivu-icon-ios-recording-outline', text: 'ios-recording-outline' },

  { name: 'ivu-icon-md-recording', text: 'md-recording' },

  { name: 'ivu-icon-logo-reddit', text: 'logo-reddit' },

  { name: 'ivu-icon-ios-redo', text: 'ios-redo' },

  { name: 'ivu-icon-ios-redo-outline', text: 'ios-redo-outline' },

  { name: 'ivu-icon-md-redo', text: 'md-redo' },

  { name: 'ivu-icon-ios-refresh', text: 'ios-refresh' },

  { name: 'ivu-icon-md-refresh', text: 'md-refresh' },

  { name: 'ivu-icon-ios-refresh-circle', text: 'ios-refresh-circle' },

  { name: 'ivu-icon-ios-refresh-circle-outline', text: 'ios-refresh-circle-outline' },

  { name: 'ivu-icon-md-refresh-circle', text: 'md-refresh-circle' },

  { name: 'ivu-icon-ios-remove', text: 'ios-remove' },

  { name: 'ivu-icon-md-remove', text: 'md-remove' },

  { name: 'ivu-icon-ios-remove-circle', text: 'ios-remove-circle' },

  { name: 'ivu-icon-ios-remove-circle-outline', text: 'ios-remove-circle-outline' },

  { name: 'ivu-icon-md-remove-circle', text: 'md-remove-circle' },

  { name: 'ivu-icon-ios-reorder', text: 'ios-reorder' },

  { name: 'ivu-icon-md-reorder', text: 'md-reorder' },

  { name: 'ivu-icon-ios-repeat', text: 'ios-repeat' },

  { name: 'ivu-icon-md-repeat', text: 'md-repeat' },

  { name: 'ivu-icon-ios-resize', text: 'ios-resize' },

  { name: 'ivu-icon-md-resize', text: 'md-resize' },

  { name: 'ivu-icon-ios-restaurant', text: 'ios-restaurant' },

  { name: 'ivu-icon-ios-restaurant-outline', text: 'ios-restaurant-outline' },

  { name: 'ivu-icon-md-restaurant', text: 'md-restaurant' },

  { name: 'ivu-icon-ios-return-left', text: 'ios-return-left' },

  { name: 'ivu-icon-md-return-left', text: 'md-return-left' },

  { name: 'ivu-icon-ios-return-right', text: 'ios-return-right' },

  { name: 'ivu-icon-md-return-right', text: 'md-return-right' },

  { name: 'ivu-icon-ios-reverse-camera', text: 'ios-reverse-camera' },

  { name: 'ivu-icon-ios-reverse-camera-outline', text: 'ios-reverse-camera-outline' },

  { name: 'ivu-icon-md-reverse-camera', text: 'md-reverse-camera' },

  { name: 'ivu-icon-ios-rewind', text: 'ios-rewind' },

  { name: 'ivu-icon-ios-rewind-outline', text: 'ios-rewind-outline' },

  { name: 'ivu-icon-md-rewind', text: 'md-rewind' },

  { name: 'ivu-icon-ios-ribbon', text: 'ios-ribbon' },

  { name: 'ivu-icon-ios-ribbon-outline', text: 'ios-ribbon-outline' },

  { name: 'ivu-icon-md-ribbon', text: 'md-ribbon' },

  { name: 'ivu-icon-ios-rose', text: 'ios-rose' },

  { name: 'ivu-icon-ios-rose-outline', text: 'ios-rose-outline' },

  { name: 'ivu-icon-md-rose', text: 'md-rose' },

  { name: 'ivu-icon-logo-rss', text: 'logo-rss' },

  { name: 'ivu-icon-ios-sad', text: 'ios-sad' },

  { name: 'ivu-icon-ios-sad-outline', text: 'ios-sad-outline' },

  { name: 'ivu-icon-md-sad', text: 'md-sad' },

  { name: 'ivu-icon-logo-sass', text: 'logo-sass' },

  { name: 'ivu-icon-ios-school', text: 'ios-school' },

  { name: 'ivu-icon-ios-school-outline', text: 'ios-school-outline' },

  { name: 'ivu-icon-md-school', text: 'md-school' },

  { name: 'ivu-icon-ios-search', text: 'ios-search' },

  { name: 'ivu-icon-ios-search-outline', text: 'ios-search-outline' },

  { name: 'ivu-icon-md-search', text: 'md-search' },

  { name: 'ivu-icon-ios-send', text: 'ios-send' },

  { name: 'ivu-icon-ios-send-outline', text: 'ios-send-outline' },

  { name: 'ivu-icon-md-send', text: 'md-send' },

  { name: 'ivu-icon-ios-settings', text: 'ios-settings' },

  { name: 'ivu-icon-ios-settings-outline', text: 'ios-settings-outline' },

  { name: 'ivu-icon-md-settings', text: 'md-settings' },

  { name: 'ivu-icon-ios-share', text: 'ios-share' },

  { name: 'ivu-icon-ios-share-outline', text: 'ios-share-outline' },

  { name: 'ivu-icon-md-share', text: 'md-share' },

  { name: 'ivu-icon-ios-share-alt', text: 'ios-share-alt' },

  { name: 'ivu-icon-ios-share-alt-outline', text: 'ios-share-alt-outline' },

  { name: 'ivu-icon-md-share-alt', text: 'md-share-alt' },

  { name: 'ivu-icon-ios-shirt', text: 'ios-shirt' },

  { name: 'ivu-icon-ios-shirt-outline', text: 'ios-shirt-outline' },

  { name: 'ivu-icon-md-shirt', text: 'md-shirt' },

  { name: 'ivu-icon-ios-shuffle', text: 'ios-shuffle' },

  { name: 'ivu-icon-md-shuffle', text: 'md-shuffle' },

  { name: 'ivu-icon-ios-skip-backward', text: 'ios-skip-backward' },

  { name: 'ivu-icon-ios-skip-backward-outline', text: 'ios-skip-backward-outline' },

  { name: 'ivu-icon-md-skip-backward', text: 'md-skip-backward' },

  { name: 'ivu-icon-ios-skip-forward', text: 'ios-skip-forward' },

  { name: 'ivu-icon-ios-skip-forward-outline', text: 'ios-skip-forward-outline' },

  { name: 'ivu-icon-md-skip-forward', text: 'md-skip-forward' },

  { name: 'ivu-icon-logo-skype', text: 'logo-skype' },

  { name: 'ivu-icon-logo-snapchat', text: 'logo-snapchat' },

  { name: 'ivu-icon-ios-snow', text: 'ios-snow' },

  { name: 'ivu-icon-ios-snow-outline', text: 'ios-snow-outline' },

  { name: 'ivu-icon-md-snow', text: 'md-snow' },

  { name: 'ivu-icon-ios-speedometer', text: 'ios-speedometer' },

  { name: 'ivu-icon-ios-speedometer-outline', text: 'ios-speedometer-outline' },

  { name: 'ivu-icon-md-speedometer', text: 'md-speedometer' },

  { name: 'ivu-icon-ios-square', text: 'ios-square' },

  { name: 'ivu-icon-ios-square-outline', text: 'ios-square-outline' },

  { name: 'ivu-icon-md-square', text: 'md-square' },

  { name: 'ivu-icon-md-square-outline', text: 'md-square-outline' },

  { name: 'ivu-icon-ios-star', text: 'ios-star' },

  { name: 'ivu-icon-ios-star-outline', text: 'ios-star-outline' },

  { name: 'ivu-icon-md-star', text: 'md-star' },

  { name: 'ivu-icon-ios-star-half', text: 'ios-star-half' },

  { name: 'ivu-icon-md-star-half', text: 'md-star-half' },

  { name: 'ivu-icon-md-star-outline', text: 'md-star-outline' },

  { name: 'ivu-icon-ios-stats', text: 'ios-stats' },

  { name: 'ivu-icon-ios-stats-outline', text: 'ios-stats-outline' },

  { name: 'ivu-icon-md-stats', text: 'md-stats' },

  { name: 'ivu-icon-logo-steam', text: 'logo-steam' },

  { name: 'ivu-icon-ios-stopwatch', text: 'ios-stopwatch' },

  { name: 'ivu-icon-ios-stopwatch-outline', text: 'ios-stopwatch-outline' },

  { name: 'ivu-icon-md-stopwatch', text: 'md-stopwatch' },

  { name: 'ivu-icon-ios-subway', text: 'ios-subway' },

  { name: 'ivu-icon-ios-subway-outline', text: 'ios-subway-outline' },

  { name: 'ivu-icon-md-subway', text: 'md-subway' },

  { name: 'ivu-icon-ios-sunny', text: 'ios-sunny' },

  { name: 'ivu-icon-ios-sunny-outline', text: 'ios-sunny-outline' },

  { name: 'ivu-icon-md-sunny', text: 'md-sunny' },

  { name: 'ivu-icon-ios-swap', text: 'ios-swap' },

  { name: 'ivu-icon-md-swap', text: 'md-swap' },

  { name: 'ivu-icon-ios-switch', text: 'ios-switch' },

  { name: 'ivu-icon-ios-switch-outline', text: 'ios-switch-outline' },

  { name: 'ivu-icon-md-switch', text: 'md-switch' },

  { name: 'ivu-icon-ios-sync', text: 'ios-sync' },

  { name: 'ivu-icon-md-sync', text: 'md-sync' },

  { name: 'ivu-icon-ios-tablet-landscape', text: 'ios-tablet-landscape' },

  { name: 'ivu-icon-md-tablet-landscape', text: 'md-tablet-landscape' },

  { name: 'ivu-icon-ios-tablet-portrait', text: 'ios-tablet-portrait' },

  { name: 'ivu-icon-md-tablet-portrait', text: 'md-tablet-portrait' },

  { name: 'ivu-icon-ios-tennisball', text: 'ios-tennisball' },

  { name: 'ivu-icon-ios-tennisball-outline', text: 'ios-tennisball-outline' },

  { name: 'ivu-icon-md-tennisball', text: 'md-tennisball' },

  { name: 'ivu-icon-ios-text', text: 'ios-text' },

  { name: 'ivu-icon-ios-text-outline', text: 'ios-text-outline' },

  { name: 'ivu-icon-md-text', text: 'md-text' },

  { name: 'ivu-icon-ios-thermometer', text: 'ios-thermometer' },

  { name: 'ivu-icon-ios-thermometer-outline', text: 'ios-thermometer-outline' },

  { name: 'ivu-icon-md-thermometer', text: 'md-thermometer' },

  { name: 'ivu-icon-ios-thumbs-down', text: 'ios-thumbs-down' },

  { name: 'ivu-icon-ios-thumbs-down-outline', text: 'ios-thumbs-down-outline' },

  { name: 'ivu-icon-md-thumbs-down', text: 'md-thumbs-down' },

  { name: 'ivu-icon-ios-thumbs-up', text: 'ios-thumbs-up' },

  { name: 'ivu-icon-ios-thumbs-up-outline', text: 'ios-thumbs-up-outline' },

  { name: 'ivu-icon-md-thumbs-up', text: 'md-thumbs-up' },

  { name: 'ivu-icon-ios-thunderstorm', text: 'ios-thunderstorm' },

  { name: 'ivu-icon-ios-thunderstorm-outline', text: 'ios-thunderstorm-outline' },

  { name: 'ivu-icon-md-thunderstorm', text: 'md-thunderstorm' },

  { name: 'ivu-icon-ios-time', text: 'ios-time' },

  { name: 'ivu-icon-ios-time-outline', text: 'ios-time-outline' },

  { name: 'ivu-icon-md-time', text: 'md-time' },

  { name: 'ivu-icon-ios-timer', text: 'ios-timer' },

  { name: 'ivu-icon-ios-timer-outline', text: 'ios-timer-outline' },

  { name: 'ivu-icon-md-timer', text: 'md-timer' },

  { name: 'ivu-icon-ios-train', text: 'ios-train' },

  { name: 'ivu-icon-ios-train-outline', text: 'ios-train-outline' },

  { name: 'ivu-icon-md-train', text: 'md-train' },

  { name: 'ivu-icon-ios-transgender', text: 'ios-transgender' },

  { name: 'ivu-icon-md-transgender', text: 'md-transgender' },

  { name: 'ivu-icon-ios-trash', text: 'ios-trash' },

  { name: 'ivu-icon-ios-trash-outline', text: 'ios-trash-outline' },

  { name: 'ivu-icon-md-trash', text: 'md-trash' },

  { name: 'ivu-icon-ios-trending-down', text: 'ios-trending-down' },

  { name: 'ivu-icon-md-trending-down', text: 'md-trending-down' },

  { name: 'ivu-icon-ios-trending-up', text: 'ios-trending-up' },

  { name: 'ivu-icon-md-trending-up', text: 'md-trending-up' },

  { name: 'ivu-icon-ios-trophy', text: 'ios-trophy' },

  { name: 'ivu-icon-ios-trophy-outline', text: 'ios-trophy-outline' },

  { name: 'ivu-icon-md-trophy', text: 'md-trophy' },

  { name: 'ivu-icon-logo-tumblr', text: 'logo-tumblr' },

  { name: 'ivu-icon-logo-tux', text: 'logo-tux' },

  { name: 'ivu-icon-logo-twitch', text: 'logo-twitch' },

  { name: 'ivu-icon-logo-twitter', text: 'logo-twitter' },

  { name: 'ivu-icon-ios-umbrella', text: 'ios-umbrella' },

  { name: 'ivu-icon-ios-umbrella-outline', text: 'ios-umbrella-outline' },

  { name: 'ivu-icon-md-umbrella', text: 'md-umbrella' },

  { name: 'ivu-icon-ios-undo', text: 'ios-undo' },

  { name: 'ivu-icon-ios-undo-outline', text: 'ios-undo-outline' },

  { name: 'ivu-icon-md-undo', text: 'md-undo' },

  { name: 'ivu-icon-ios-unlock', text: 'ios-unlock' },

  { name: 'ivu-icon-ios-unlock-outline', text: 'ios-unlock-outline' },

  { name: 'ivu-icon-md-unlock', text: 'md-unlock' },

  { name: 'ivu-icon-logo-usd', text: 'logo-usd' },

  { name: 'ivu-icon-ios-videocam', text: 'ios-videocam' },

  { name: 'ivu-icon-ios-videocam-outline', text: 'ios-videocam-outline' },

  { name: 'ivu-icon-md-videocam', text: 'md-videocam' },

  { name: 'ivu-icon-logo-vimeo', text: 'logo-vimeo' },

  { name: 'ivu-icon-ios-volume-down', text: 'ios-volume-down' },

  { name: 'ivu-icon-md-volume-down', text: 'md-volume-down' },

  { name: 'ivu-icon-ios-volume-mute', text: 'ios-volume-mute' },

  { name: 'ivu-icon-md-volume-mute', text: 'md-volume-mute' },

  { name: 'ivu-icon-ios-volume-off', text: 'ios-volume-off' },

  { name: 'ivu-icon-md-volume-off', text: 'md-volume-off' },

  { name: 'ivu-icon-ios-volume-up', text: 'ios-volume-up' },

  { name: 'ivu-icon-md-volume-up', text: 'md-volume-up' },

  { name: 'ivu-icon-ios-walk', text: 'ios-walk' },

  { name: 'ivu-icon-md-walk', text: 'md-walk' },

  { name: 'ivu-icon-ios-warning', text: 'ios-warning' },

  { name: 'ivu-icon-ios-warning-outline', text: 'ios-warning-outline' },

  { name: 'ivu-icon-md-warning', text: 'md-warning' },

  { name: 'ivu-icon-ios-watch', text: 'ios-watch' },

  { name: 'ivu-icon-md-watch', text: 'md-watch' },

  { name: 'ivu-icon-ios-water', text: 'ios-water' },

  { name: 'ivu-icon-ios-water-outline', text: 'ios-water-outline' },

  { name: 'ivu-icon-md-water', text: 'md-water' },

  { name: 'ivu-icon-logo-whatsapp', text: 'logo-whatsapp' },

  { name: 'ivu-icon-ios-wifi', text: 'ios-wifi' },

  { name: 'ivu-icon-ios-wifi-outline', text: 'ios-wifi-outline' },

  { name: 'ivu-icon-md-wifi', text: 'md-wifi' },

  { name: 'ivu-icon-logo-windows', text: 'logo-windows' },

  { name: 'ivu-icon-ios-wine', text: 'ios-wine' },

  { name: 'ivu-icon-ios-wine-outline', text: 'ios-wine-outline' },

  { name: 'ivu-icon-md-wine', text: 'md-wine' },

  { name: 'ivu-icon-ios-woman', text: 'ios-woman' },

  { name: 'ivu-icon-ios-woman-outline', text: 'ios-woman-outline' },

  { name: 'ivu-icon-md-woman', text: 'md-woman' },

  { name: 'ivu-icon-logo-wordpress', text: 'logo-wordpress' },

  { name: 'ivu-icon-logo-xbox', text: 'logo-xbox' },

  { name: 'ivu-icon-logo-yahoo', text: 'logo-yahoo' },

  { name: 'ivu-icon-logo-yen', text: 'logo-yen' },

  { name: 'ivu-icon-logo-youtube', text: 'logo-youtube' },

  { name: 'ivu-icon-ios-loading', text: 'ios-loading' },
]
